var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4658_27001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8985 0.585938H18.711V19.4141H10.8985M16.3672 3.75002L13.2032 3.75L13.2032 0.585959M16.3672 3.75002L13.2032 0.585959M16.3672 3.75002V19.4141H1.28912V0.585959H13.2032M8.7586 9.92252C6.82189 9.95983 5.25396 11.5507 5.25396 13.4961C5.25396 15.4647 6.85954 17.0703 8.82818 17.0703C10.7226 17.0703 12.2808 15.5835 12.3956 13.7172M8.82817 13.4765L6.54302 15.7617M3.63287 2.92973H10.8594M3.63287 5.27347H10.8985M3.63287 7.61721H6.99224M8.82817 13.4961V9.02342C11.2983 9.02342 13.3008 11.0259 13.3008 13.4961H8.82817Z",
    stroke: "#706F7B",
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4658_27001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.ab813d0add46c0340b5bd4289e4d77b5.svg";
export { ForwardRef as ReactComponent };